import { AhooksInfiniteScrollFrame } from "@/components/AhooksInfiniteScrollFrame";
import { Icon } from "@/components/Icon";
import { cn } from "@/libs";
import { Button, Grid, Popover, PullToRefresh, SafeArea } from "antd-mobile";
import { ListFilter } from "./Filter";
import styles from "../index.module.scss";
import { useSetup } from "./listLogic";
import { CryptoOrederInfo } from "@/types/Api/Crypto";
import { myOrdersColumns } from "@/constants/order/key";
import { List as AList } from 'antd-mobile';
import moduleStyles from "./styles.module.scss";
import { useImperativeHandle, forwardRef } from "react";
const Item = ({
  item,
  onClick
}: {
  item: CryptoOrederInfo;
  onClick: () => void;
}) => {
  return <div key={item.orderNo} onClick={onClick} className={cn(moduleStyles.listTable, moduleStyles.list_row)} data-sentry-component="Item" data-sentry-source-file="List.tsx">
    <Grid columns={24} gap={0} data-sentry-element="Grid" data-sentry-source-file="List.tsx">
      {myOrdersColumns.map((col, index: number) => {
        const key = (col.dataIndex as keyof CryptoOrederInfo);
        const value = item[key];
        return <Grid.Item span={col.span || 24} key={`${index}_${col.dataIndex}`}>
          {typeof col.render === "function" ? col.render(value, item) : value || "-"}
        </Grid.Item>;
      })}
    </Grid>
  </div>;
};
export const List = forwardRef((props, ref) => {
  const logic = useSetup();
  useImperativeHandle(ref, () => ({
    childMethod: () => {
      console.log('子组件方法调用');
      logic.infiniteList.reloadAsync();
    }
  }));
  return <div ref={logic.scollableRef}>
      <PullToRefresh onRefresh={() => logic.infiniteList.reloadAsync()}>
        <div className={styles.main}>
          <div className={cn(moduleStyles.listTable, styles.list)}>
            <div className={styles.listHeader}>
              排序方式
              <Button fill="none" className={styles.listFilterButton} onClick={() => {
              logic.dispatch({
                type: "update-showFilterPopup",
                showFilterPopup: true
              });
            }}>
                <Icon name="filter" size={"20px"} />
              </Button>
            </div>
            <AList className={cn(moduleStyles.listTable, moduleStyles.listTableHeader)}>
                <Grid columns={24} gap={0} className={cn(moduleStyles.listTableHeaderItem)}>
                  {myOrdersColumns.map(col => <Grid.Item span={col.span || 24} key={col.dataIndex}>
                      {col.title}
                    </Grid.Item>)}
                </Grid>
            </AList>
            <AhooksInfiniteScrollFrame {...logic.infiniteList}>
              {logic.infiniteList.data?.list?.length ? logic.infiniteList.data?.list.filter(item => logic.userInfo.userId === item.sellerId).map(item => {
              return <Item item={(item as any)} key={item.pendingOrderNo} onClick={() => {
                logic.navigate(`/selling/${item.pendingOrderId}?m=${item.isBusiness === 2 ? "2" : "1"}`);
              }} />;
            }) : null}
            </AhooksInfiniteScrollFrame>
          </div>
        </div>
        <div className={styles.whitespace}></div>
      </PullToRefresh>
      <SafeArea position="bottom" />
      <ListFilter tradePaymentOptions={logic.tradePayments} logic={logic} visible={logic.state.showFilterPopup} onClose={() => {
      logic.dispatch({
        type: "update-showFilterPopup",
        showFilterPopup: false
      });
    }} closeOnMaskClick={true} />
    </div>;
});